import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default')
  },

  privateCat: {
    color: theme.palette.indicator.red
  },

  noneCat: {
    color: 'lightgrey'
  }
}))

export default useStyles
